'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.OSOBA = exports.TEL = exports.EMAIL = exports.DS = exports.ADRDOR = exports.ADRDORREG = exports.ADRTRVSDL = exports.ADR = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T22:22:50Z                      #

// ##############################################################

/**
 * Určuje typ kontaktu.
 */

/**
 * Adresa.
 */
var ADR = exports.ADR = 'ADR';

/**
 * Adresa trvalého pobytu/sídla.
 */
var ADRTRVSDL = exports.ADRTRVSDL = 'ADRTRVSDL';

/**
 * Doručovací adresa z registrů.
 */
var ADRDORREG = exports.ADRDORREG = 'ADRDORREG';

/**
 * Kontaktní doručovací adresa.
 */
var ADRDOR = exports.ADRDOR = 'ADRDOR';

/**
 * Datová schránka.
 */
var DS = exports.DS = 'DS';

/**
 * E-mail.
 */
var EMAIL = exports.EMAIL = 'EMAIL';

/**
 * Telefon.
 */
var TEL = exports.TEL = 'TEL';

/**
 * Kontaktní osoba.
 */
var OSOBA = exports.OSOBA = 'OSOBA';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [ADR, ADRTRVSDL, ADRDORREG, ADRDOR, DS, EMAIL, TEL, OSOBA];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, ADR, { caption: 'Adresa.' }), (0, _defineProperty3.default)(_params, ADRTRVSDL, { caption: 'Adresa trvalého pobytu/sídla.' }), (0, _defineProperty3.default)(_params, ADRDORREG, { caption: 'Doručovací adresa z registrů.' }), (0, _defineProperty3.default)(_params, ADRDOR, { caption: 'Kontaktní doručovací adresa.' }), (0, _defineProperty3.default)(_params, DS, { caption: 'Datová schránka.' }), (0, _defineProperty3.default)(_params, EMAIL, { caption: 'E-mail.' }), (0, _defineProperty3.default)(_params, TEL, { caption: 'Telefon.' }), (0, _defineProperty3.default)(_params, OSOBA, { caption: 'Kontaktní osoba.' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvYXBpL2dlbi9wcm94aW9hcGkvVHlwS29udGFrdHUuanN4Il0sIm5hbWVzIjpbImdldENhcHRpb24iLCJBRFIiLCJBRFJUUlZTREwiLCJBRFJET1JSRUciLCJBRFJET1IiLCJEUyIsIkVNQUlMIiwiVEVMIiwiT1NPQkEiLCJ2YWx1ZXMiLCJwYXJhbXMiLCJjYXB0aW9uIiwidmFsdWUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7UUF1RmdCQSxVLEdBQUFBLFU7Ozs7QUF2RmhCO0FBQ0E7O0FBRUE7O0FBRUE7O0FBRUE7O0FBRUE7O0FBRUE7Ozs7QUFJQTs7O0FBR08sSUFBTUMsb0JBQU0sS0FBWjs7QUFFUDs7O0FBR08sSUFBTUMsZ0NBQVksV0FBbEI7O0FBRVA7OztBQUdPLElBQU1DLGdDQUFZLFdBQWxCOztBQUVQOzs7QUFHTyxJQUFNQywwQkFBUyxRQUFmOztBQUVQOzs7QUFHTyxJQUFNQyxrQkFBSyxJQUFYOztBQUVQOzs7QUFHTyxJQUFNQyx3QkFBUSxPQUFkOztBQUVQOzs7QUFHTyxJQUFNQyxvQkFBTSxLQUFaOztBQUVQOzs7QUFHTyxJQUFNQyx3QkFBUSxPQUFkOztBQUVQOzs7QUFHTyxJQUFNQywwQkFBUyxDQUNsQlIsR0FEa0IsRUFFbEJDLFNBRmtCLEVBR2xCQyxTQUhrQixFQUlsQkMsTUFKa0IsRUFLbEJDLEVBTGtCLEVBTWxCQyxLQU5rQixFQU9sQkMsR0FQa0IsRUFRbEJDLEtBUmtCLENBQWY7O0FBV1A7OztBQUdBLElBQU1FLCtEQUNEVCxHQURDLEVBQ0ssRUFBQ1UsU0FBUyxTQUFWLEVBREwsMENBRURULFNBRkMsRUFFVyxFQUFDUyxTQUFTLCtCQUFWLEVBRlgsMENBR0RSLFNBSEMsRUFHVyxFQUFDUSxTQUFTLCtCQUFWLEVBSFgsMENBSURQLE1BSkMsRUFJUSxFQUFDTyxTQUFTLDhCQUFWLEVBSlIsMENBS0ROLEVBTEMsRUFLSSxFQUFDTSxTQUFTLGtCQUFWLEVBTEosMENBTURMLEtBTkMsRUFNTyxFQUFDSyxTQUFTLFNBQVYsRUFOUCwwQ0FPREosR0FQQyxFQU9LLEVBQUNJLFNBQVMsVUFBVixFQVBMLDBDQVFESCxLQVJDLEVBUU8sRUFBQ0csU0FBUyxrQkFBVixFQVJQLFdBQU47O0FBV0E7Ozs7QUFJTyxTQUFTWCxVQUFULENBQW9CWSxLQUFwQixFQUEyQjtBQUM5QixTQUFPRixPQUFPRSxLQUFQLEVBQWNELE9BQXJCO0FBQ0giLCJmaWxlIjoiVHlwS29udGFrdHUuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAQ29uZlxuLy8gI2hhc0RvYz10cnVlXG5cbi8vICMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjXG5cbi8vICMgICAgICAgICAgICAgR0VORVJPVkFOw50gS8OTRCwgTkVNT0RJRklLT1ZBVCEhISEgICAgICAgICAgICAgICNcblxuLy8gIyAgICAgICAgICAgICAgICAgIDIwMjUtMDEtMDdUMjI6MjI6NTBaICAgICAgICAgICAgICAgICAgICAgICNcblxuLy8gIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyNcblxuLyoqXG4gKiBVcsSNdWplIHR5cCBrb250YWt0dS5cbiAqL1xuXG4vKipcbiAqIEFkcmVzYS5cbiAqL1xuZXhwb3J0IGNvbnN0IEFEUiA9ICdBRFInO1xuXG4vKipcbiAqIEFkcmVzYSB0cnZhbMOpaG8gcG9ieXR1L3PDrWRsYS5cbiAqL1xuZXhwb3J0IGNvbnN0IEFEUlRSVlNETCA9ICdBRFJUUlZTREwnO1xuXG4vKipcbiAqIERvcnXEjW92YWPDrSBhZHJlc2EgeiByZWdpc3Ryxa8uXG4gKi9cbmV4cG9ydCBjb25zdCBBRFJET1JSRUcgPSAnQURSRE9SUkVHJztcblxuLyoqXG4gKiBLb250YWt0bsOtIGRvcnXEjW92YWPDrSBhZHJlc2EuXG4gKi9cbmV4cG9ydCBjb25zdCBBRFJET1IgPSAnQURSRE9SJztcblxuLyoqXG4gKiBEYXRvdsOhIHNjaHLDoW5rYS5cbiAqL1xuZXhwb3J0IGNvbnN0IERTID0gJ0RTJztcblxuLyoqXG4gKiBFLW1haWwuXG4gKi9cbmV4cG9ydCBjb25zdCBFTUFJTCA9ICdFTUFJTCc7XG5cbi8qKlxuICogVGVsZWZvbi5cbiAqL1xuZXhwb3J0IGNvbnN0IFRFTCA9ICdURUwnO1xuXG4vKipcbiAqIEtvbnRha3Ruw60gb3NvYmEuXG4gKi9cbmV4cG9ydCBjb25zdCBPU09CQSA9ICdPU09CQSc7XG5cbi8qKlxuICogU2V6bmFtIHbFoWVjaCBob2Rub3QuXG4gKi9cbmV4cG9ydCBjb25zdCB2YWx1ZXMgPSBbXG4gICAgQURSLFxuICAgIEFEUlRSVlNETCxcbiAgICBBRFJET1JSRUcsXG4gICAgQURSRE9SLFxuICAgIERTLFxuICAgIEVNQUlMLFxuICAgIFRFTCxcbiAgICBPU09CQVxuXTtcblxuLyoqXG4gKiBNYXBhIGVudW11IG5hIG9iamVrdCBzIHBvZHJvYm5vc3RtaSBvIGVudW11LlxuICovXG5jb25zdCBwYXJhbXMgPSB7XG4gICAgW0FEUl06IHtjYXB0aW9uOiAnQWRyZXNhLid9LFxuICAgIFtBRFJUUlZTRExdOiB7Y2FwdGlvbjogJ0FkcmVzYSB0cnZhbMOpaG8gcG9ieXR1L3PDrWRsYS4nfSxcbiAgICBbQURSRE9SUkVHXToge2NhcHRpb246ICdEb3J1xI1vdmFjw60gYWRyZXNhIHogcmVnaXN0csWvLid9LFxuICAgIFtBRFJET1JdOiB7Y2FwdGlvbjogJ0tvbnRha3Ruw60gZG9ydcSNb3ZhY8OtIGFkcmVzYS4nfSxcbiAgICBbRFNdOiB7Y2FwdGlvbjogJ0RhdG92w6Egc2NocsOhbmthLid9LFxuICAgIFtFTUFJTF06IHtjYXB0aW9uOiAnRS1tYWlsLid9LFxuICAgIFtURUxdOiB7Y2FwdGlvbjogJ1RlbGVmb24uJ30sXG4gICAgW09TT0JBXToge2NhcHRpb246ICdLb250YWt0bsOtIG9zb2JhLid9XG59O1xuXG4vKipcbiAqIE5hxI10ZW7DrSBwb3Bpc2t1IGVudW11LlxuICogQHJldHVybiBwb3Bpc2VrIGVudW11XG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBnZXRDYXB0aW9uKHZhbHVlKSB7XG4gICAgcmV0dXJuIHBhcmFtc1t2YWx1ZV0uY2FwdGlvbjtcbn0iXX0=